<template>
  <!-- 新增签约产品弹窗 -->
  <el-dialog id="nn" class="dialogClass" title="新加签约产品" :close-on-click-modal="false" :visible="showDialog"
    :width="'55%'" :append-to-body="true" @close="closeShowDialog">
    <el-form ref="FormData" :model="FormData"   :rules="rules">
      <!-- <el-form-item label="开始日期" label-width="80px">
        <el-date-picker
          v-model="FormData.startTime"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 100%;"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="有效期至" label-width="80px">
        <el-date-picker
          v-model="FormData.endTime"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 100%;"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item> -->
      <el-form-item label="课程" label-width="100px">
        <!-- <el-input v-model="FormData.categoryId"></el-input> -->
        <el-select class="select" clearable v-model="FormData.categoryId" placeholder="请选择课程" style="width:100%;">
          <el-option v-for="source in courses" :key="source.id" :value="source.id" :label="source.categoryName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班型" label-width="100px">
        <el-select class="select" clearable v-model="classType" placeholder="请选择班型" style="width:100%;">
          <el-option v-for="source in lessonList" :key="source.id" :value="source.id" :label="source.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进老师" label-width="100px">
        <el-select class="select" clearable v-model="FormData.teacherList" filterable placeholder="请选择跟进老师" style="width:100%;">
          <el-option v-for="source in teacherLists" :key="source.id" :value="source.id" :label="source.realname">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课节数" label-width="100px">
        <el-input v-model="FormData.lessonNum" placeholder="请输入课节数"></el-input>
      </el-form-item>
      <el-form-item label="课时单价" label-width="100px">
        <el-input v-model="FormData.lessonPrice" placeholder="请输入课时单价"></el-input>
      </el-form-item>

      <el-form-item label="上课方式" label-width="100px">
        <el-select placeholder="请选择上课方式" v-model="FormData.educationType"  style="width: 100%" clearable filterable multiple>
              <el-option v-for="item in optionList4" :key="item.id" :value="item.id" :label="item.name"></el-option>
       </el-select>
      </el-form-item>


      <el-form-item label="销售:" label-width="100px"  prop="inputAcount">
        <el-select v-model="inputAcount" filterable  clearable style="width: 100%" placeholder="请选择销售">
          <el-option v-for="item in optionsList" :key="item.saleId" :label="item.label" :value="item.saleId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="规划师" label-width="100px"  prop="searchSource222">
        <el-select v-model="searchSource222" clearable filterable style="width: 100%"  placeholder="请选择是否结清">
          <el-option v-for="item in sources222" :key="item.teacherId" :label="item.teacherName" :value="item.teacherId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="扩科/转介绍" label-width="100px">
        <el-select placeholder="请选择扩科/转介绍" v-model="FormData.isExpand"  style="width: 100%" clearable filterable >
              <el-option v-for="item in isExpandList" :key="item.id" :value="item.id" :label="item.name"></el-option>
       </el-select>
      </el-form-item>

      <el-form-item label="在职老师" label-width="100px">
        <el-select placeholder="请选择在职老师" v-model="FormData.expandTeacherId"  style="width: 100%" clearable filterable >
              <el-option v-for="item in expandTeacherIdList" :key="item.id" :value="item.id" :label="item.realname"></el-option>
       </el-select>
      </el-form-item>


      <el-form-item label="远程路补" label-width="100px">
        <el-input v-model="FormData.RemoteRoadRepair" placeholder="请输入远程路补"></el-input>
      </el-form-item>



      <!-- <el-form-item label="老师状态" label-width="80px">
         <el-radio v-model="radio" :label="2"  >未流失</el-radio>
         <el-radio v-model="radio" :label="1"  @click.native="handleClickradio">流失</el-radio>
         <el-radio v-model="radio" :label="3"  @click.native="handleClickradio">结业</el-radio>
       </el-form-item>

       <el-form-item label="流失时间" label-width="80px" v-if="radio == 1">
         <el-date-picker
           v-model="ReasonsTime"
           value-format="yyyy-MM-dd"
           type="date"
           placeholder="选择日期"
         >
         </el-date-picker>
       </el-form-item>

       <el-form-item label="流失原因" label-width="80px" v-if="radio == 1">
         <el-input
           v-model="Reasons"
           type="textarea"
           placeholder="请输入内容"
           :autosize="{ minRows: 6, maxRows: 6 }"
           maxlength="300"
           show-word-limit
         ></el-input>
       </el-form-item>

       <el-form-item label="结业时间" label-width="80px" v-if="radio == 3">
         <el-date-picker
           v-model="ReasonsTime"
           value-format="yyyy-MM-dd"
           type="date"
           placeholder="选择日期"
         >
         </el-date-picker>
       </el-form-item>

       <el-form-item label="结业原因" label-width="80px" v-if="radio == 3">
         <el-input
           v-model="Reasons"
           type="textarea"
           placeholder="请输入内容"
           :autosize="{ minRows: 6, maxRows: 6 }"
           maxlength="300"
           show-word-limit
         ></el-input>
       </el-form-item> -->



      <!-- <el-form-item label="签约方案" label-width="80px">
        <el-radio @click.native.prevent="clickitem(item.id)" border v-model="contractId"
          style="width: 130px; height: 230px; margin-left:10px; margin-bottom: 20px; overflow: auto; max-height: 230px;"
          v-for="(item, index) in planArr" :key="index" :label='item.id'>
          <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
          <div style="text-align: left;" v-for="(item1, index1) in item.planList" :key="index1">
            <p>课节数:{{ item1.classNum }}</p>
            <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
          </div>
        </el-radio>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeShowDialog" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="handleOkClick">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  props: ["id"],
  data () {
    return {
      contractId: '',
      teacherLists: [],//所有老师
      optionList4: [{ id: 1, name: '网课' }, { id: 2, name: '上门' }, { id: 3, name: '门店' }],
      showDialog: false,
      planArr: [
      ],
      lessonList: [
        {
          id: 1,
          value: 1,
          name: "1v1"
        },
        {
          id: 2,
          value: 2,
          name: "1v2"
        },
        {
          id: 3,
          value: 3,
          name: "1v3"
        }
      ], //班型
      classType: 1,
      FormData: {
        studentId: this.id,
        // classType:"1v1",
        startTime: "",
        isExpand: "",
        expandTeacherId: "",
        RemoteRoadRepair: "",

        lessonNum: "",
        lessonPrice: "",
        endTime: "",
        teacherList: "",//跟进老师
        educationType:[]
      },
      requestParameters: {
        pageSize: 10000, //每页多少条
        pageNum: 1, //当前显示页码
      },
      courses: [],

      radio: 0,
      ReasonsTime: null,
      Reasons: "",


      expandTeacherIdList:[],
      isExpandList:[{ name:'否' ,id: 1 },{name:'是' ,id: 2}],

      optionsList:[],
      sources222:[],

      inputAcount: "",
      searchSource222: "",

      rules: {
        inputAcount: [
          { required: true, message: "请选择销售", trigger: "change" },
        ],
        searchSource222: [
          { required: true, message: "请选择规划师", trigger: "change" },
        ],
      },

    };
  },
  created () {
    this.getLessonList();
    this.fetchCourses();
    this.getTeacherList()
    this.getAllPlan()
  },

  mounted () {
    this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj'))
    this.sources222 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))

    axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
       this.expandTeacherIdList = response.data.data
    })
  },

  methods: {
    //获取所有方案
    getAllPlan () {
      axios
        .post(`${apiBaseUrl}/contract/getList`, this.requestParameters,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          console.log(res.data.data.records, '111111111111111111111');
          this.planArr = res.data.data.records
        })
        .catch(error => {
          console.error(error);
        });
    },
    clickitem (val) {
      // val != this.contractId ? val == this.contractId ? this.contractId = '' : this.contractId = val : this.contractId = ""
      // this.contractId = val
      if (this.contractId == val) {
        this.contractId = ""
      } else {
        this.contractId = val
      }
    },
    //获取老师列表
    getTeacherList () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherlist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.teacherLists = response.data.data; // 将获取的数据赋值给teachers数组
        })
        .catch(error => {
          console.error(error);
        });
    },

    handleClickradio() {
      this.ReasonsTime = null;
      this.Reasons = "";
    },
    //点击保存
    handleOkClick () {

      if(!this.inputAcount && !this.searchSource222){
         this.$message.error("请选择销售，规划师");
         return
      }

      const data = {
        contractId:this.contractId,
        categoryId: this.FormData.categoryId,
        studentId: this.id,
        startTime: this.FormData.startTime,
        endTime: this.FormData.endTime,
        classType: this.classType,
        lessonNum: this.FormData.lessonNum,
        lessonPrice: this.FormData.lessonPrice,
        teacherId: this.FormData.teacherList,
        educationType : this.FormData.educationType.length > 0 ? this.FormData.educationType.join(',') : null,

        isExpand: this.FormData.isExpand,
        expandTeacherId: this.FormData.expandTeacherId,
        wayMoney: this.FormData.RemoteRoadRepair,
        // lossStatus: this.radio ? this.radio : 0,
        // lossReasson: this.Reasons,
        // lossTime: this.ReasonsTime || null,
        saleId: this.inputAcount,
        projectTeacherId: this.searchSource222,
      };
      // this.FormData.studentId = this.id;
      axios
        .post(`${apiBaseUrl}/product/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            //成功
            this.$message({
              message: res.data.message || res.data.msg,
              type: "success"
            });
            this.showDialog = false
            // this.FormData = {}
            //子传父--添加成功刷新列表
            this.$emit("refresh");
          } else {
            //失败
            this.$message({
              message: res.data.message || res.data.msg,
              type: "error"
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    //获取班型列表
    getLessonList () {
      // axios
      //   .get(`${apiBaseUrl}/product/getClassType`)
      //   .then(res => {
      //     // console.log(res, "kkkkkkkkkkkkkkkkkkk");
      //     this.lessonList = res.data.data;
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    //查询课程列表
    fetchCourses () {
      axios
        .get(`${apiBaseUrl}/schedule/categorylist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.courses = response.data.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    init () {
      this.FormData = {}
      this.showDialog = true;
    },
    //点击取消
    closeShowDialog () {
      this.inputAcount = ""
      this.searchSource222 = ""
      this.showDialog = false;
    }
  }
};
</script>

<style scoped>
/* /deep/ .el-radio__input {
  position: absolute;
  left: 10px;
  top: 3px;
  z-index: 100;
} */

/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  #nn>>>.el-dialog {
    width: 70% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/manager/components/ContractProducts.vue